/** 路由路径集中定义 */

export const pathNames = {
  home: "/",
  productDetail: (slug: string) => `/products/${slug}`,
  about: "/about",
  faq: "/support/faq",
  contact: "/support/contact",
  privacy: "/support/privacy",
  refund: "/support/refund",
  notFound: "/not-found",
} as const;
